import React from "react";

/**
 * Central Solar — Pure SVG logo
 * Gold sun with rays, ringed by a white circle.
 */
const Logo = ({ className = "", variant = "dark" }) => {
  const ink = variant === "light" ? "#F7F6F2" : "#1A3626";
  const gold = "#F5C242";
  return (
    <div className={`flex items-center gap-3.5 ${className}`} data-testid="brand-logo">
      <svg viewBox="0 0 48 48" className="h-12 w-12 sm:h-14 sm:w-14" aria-hidden>
        {/* white badge / halo */}
        <circle cx="24" cy="24" r="22" fill="#FFFFFF" stroke="#D2D7D0" strokeWidth="0.8" />
        {/* gold sun */}
        <circle cx="24" cy="24" r="8.5" fill={gold} />
        {/* rays */}
        {[...Array(8)].map((_, i) => {
          const a = (i * Math.PI) / 4;
          const x1 = 24 + Math.cos(a) * 12.5;
          const y1 = 24 + Math.sin(a) * 12.5;
          const x2 = 24 + Math.cos(a) * 18;
          const y2 = 24 + Math.sin(a) * 18;
          return (
            <line
              key={i}
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
              stroke={gold}
              strokeWidth="2.4"
              strokeLinecap="round"
            />
          );
        })}
      </svg>
      <div className="flex flex-col leading-tight">
        <span
          className="font-display text-xl sm:text-2xl tracking-tight font-medium"
          style={{ color: ink }}
        >
          Central Solar
        </span>
        <span
          className="text-[10px] tracking-[0.28em] uppercase mt-1"
          style={{ color: variant === "light" ? "rgba(247,246,242,0.7)" : "#5C6B61" }}
        >
          New Plymouth · NZ
        </span>
      </div>
    </div>
  );
};

export default Logo;
